import { Routes } from '../../../../constants/routes';

const {
  FunNameGuides,
  FunDogActivitiesGuides,
  FunBlog,
  KnowledgeCareGuides,
  TrainingGuides,
  KnowledgeBreedGuides,
  KnowledgeWellnessGuides,
  KnowledgeSenseGuides,
  KnowledgeBehaviorGuides,
  KnowlegeGroomingGuides,
  LifestyleParksGuides,
  LifestyleBeachesGuides,
  LifestyleCampgroundsGuides,
  LifestyleTrailsGuides,
  LifestyleDogOwnership,
  LifestyleHolidayGuides,
  LifestyleProductGuides,
  DogVideos,
  WagServicesDogWalking,
  WagServicesDogSitting,
  WagServicesDogBoarding,
  WagServicesDogTraining,
  WagServicesDropIns,
  WagServicesWagWellness,
  Deals,
} = Routes;

export const funLinksData = {
  key: 'fun',
  url: '',
  label: 'Fun',
  subRoutes: [
    {
      key: 'names',
      url: FunNameGuides,
      label: 'Dog Names',
    },
    {
      key: 'dogActivities',
      url: FunDogActivitiesGuides,
      label: 'Dog Activities',
    },
    {
      key: 'blog',
      url: FunBlog,
      label: 'Blog',
    },
  ],
};

export const dealsPillLinkData = {
  url: Deals,
  label: 'Deals 🔥',
};

export const knowledgeLinksData = {
  key: 'knowledge',
  url: '',
  label: 'Pet Knowledge',
  subRoutes: [
    {
      key: 'petHealth',
      url: KnowledgeCareGuides,
      label: 'Pet Health',
    },
    {
      key: 'training',
      url: TrainingGuides,
      label: 'Training',
    },
    {
      key: 'breeds',
      url: KnowledgeBreedGuides,
      label: 'Breeds',
    },
    {
      key: 'senses',
      url: KnowledgeSenseGuides,
      label: 'Senses',
    },
    {
      key: 'grooming',
      url: KnowlegeGroomingGuides,
      label: 'Grooming',
    },
    {
      key: 'behavior',
      url: KnowledgeBehaviorGuides,
      label: 'Behavior',
    },
    {
      key: 'wellness',
      url: KnowledgeWellnessGuides,
      label: 'Wellness',
    },
  ],
};

export const lifestyleLinksData = {
  key: 'lifestyle',
  url: '',
  label: 'Lifestyle',
  subRoutes: [
    {
      key: 'parks',
      url: LifestyleParksGuides,
      label: 'Parks',
    },
    {
      key: 'beaches',
      url: LifestyleBeachesGuides,
      label: 'Beaches',
    },
    {
      key: 'campgrounds',
      url: LifestyleCampgroundsGuides,
      label: 'Campgrounds',
    },
    {
      key: 'trails',
      url: LifestyleTrailsGuides,
      label: 'Trails',
    },
    {
      key: 'petOwnership',
      url: LifestyleDogOwnership,
      label: 'Pet Ownership',
    },
    {
      key: 'holiday',
      url: LifestyleHolidayGuides,
      label: 'Holidays',
    },
    {
      key: 'products',
      url: LifestyleProductGuides,
      label: 'Products',
    },
  ],
};

export const dogVideosData = {
  key: 'videos',
  url: DogVideos,
  label: 'Videos',
};

export const wagServicesData = {
  key: 'wagServices',
  url: '',
  label: 'Services',
  subRoutes: [
    {
      key: 'dogWalking',
      url: WagServicesDogWalking,
      label: 'Wag! Walk',
    },
    {
      key: 'sitting',
      url: WagServicesDogSitting,
      label: 'Sitting',
    },
    {
      key: 'boarding',
      url: WagServicesDogBoarding,
      label: 'Boarding',
    },
    {
      key: 'inHomeTraining',
      url: WagServicesDogTraining,
      label: 'In-Home Training',
    },
    {
      key: 'dropIns',
      url: WagServicesDropIns,
      label: 'Drop-In Visits',
    },
    {
      key: 'wagWellness',
      url: WagServicesWagWellness,
      label: 'Wellness',
    },
  ],
};
